module.exports = __webpack_public_path__ + "344646fcc51d85ef7e64ad6d486ec86c.png";